import React, {useEffect, useState} from "react";
import I18n from 'i18n.js.erb'
import { displayTranslations, titleize } from "../../utils/utils";
import PlaceholderImage from "./PlaceholderImage";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import IconTooltip from "./IconTooltip";
import TextOverlayOnImage from "./TextOverlayOnImage";

const BlueprintImageItem = ({
    blueprintImage,
    checkFilters,
    onCheckHandler,
    onKeyDownQuantity,
    onChangeQuantity,
    displayVariantsHandler,
    modalOpened,
    atLeastOneVariantChecked,
    handleNavigation,
    gameName,
    i,
    blueprintImageMediumImageUrl
  }) => {

  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)

  const medium_image_url = blueprintImageMediumImageUrl ? blueprintImageMediumImageUrl(blueprintImage) : blueprintImage.medium_image_url

  return checkFilters(blueprintImage) ? (
      <div className="w-block-bpi p-0" >
        <div
          className="mt-5 custom-header container position-relative m-1 p-sm-1 text-dark text-center rounded mb-70px-imp m-auto border-radius-none-imp"
          key={blueprintImage.id}
          data-id={blueprintImage.id}
          style={
            blueprintImage.checked ||
            (atLeastOneVariantChecked(blueprintImage) && !modalOpened)
              ? {
                backgroundColor: "trasparent",
                border: "1px solid #000000",
                boxShadow: "5px 5px 5px rgba(68, 68, 68, 0.6)",
              }
              : {}
          }
          onClick={onCheckHandler}
        >
          <label htmlFor={blueprintImage.id} >
            <div
              className={`d-flex justify-content-center align-items-center ${blueprintImage.encasing_id && 'cursor-pointer'}`}
              style={{minHeight: "150px"}}
            >
              <div className="position-relative" style={{minWidth: "20px"}}>
                 {
                   blueprintImage.rarity_logo_url &&
                    <img
                      className="position-absolute variant-position"
                      src={blueprintImage.rarity_logo_url}
                      alt=""
                      style={ blueprintImage.en_name &&
                      blueprintImage.meta_name !==
                      blueprintImage.en_name ? {top: "-33px"} :{top:"-23px"}
                      }
                    />
                 }
              </div>
              <div className="noselect">
                {blueprintImageNames.length > 1 ? (
                  <div className="noselect text-center" style={{maxWidth: "150px"}}>
                    <p className="font-title text-space text-dark mb-2" style={{fontWeight: "500"}}>
                      {blueprintImageNames[0]}
                    </p>
                    <p className="font-title text-space text-dark mb-1"
                       style={{fontWeight: "500"}}>
                      {blueprintImageNames[1]}
                    </p>
                    <p className="text--size-09rem">
                      {blueprintImage.collector_number}
                    </p>
                  </div>
                ) : (
                  <React.Fragment>
                    <p className="text-dark-gray noselect title-card mb-0">
                      {blueprintImageNames[0]}
                    </p>

                    <p className="text--size-09rem text-left">
                      {blueprintImage.collector_number}
                    </p>
                  </React.Fragment>
                )}
              </div>
            </div>

            {modalOpened && (
              <div
                className="d-flex justify-content-around align-items-center mb-1"
                style={{minHeight: "20px"}}
              >
                {blueprintImage.print_sheet_code
                  ? blueprintImage.print_sheet_code
                  : ""}
              </div>
            ) }

            <input
              type="checkbox"
              checked={
                blueprintImage.checked ||
                (atLeastOneVariantChecked(blueprintImage) && !modalOpened)
              }
              id={blueprintImage.id}
              onChange={() => {}}
              className={`option-input checkbox ${
                blueprintImage.checked ||
                (atLeastOneVariantChecked(blueprintImage) && !modalOpened)
                  ? "checkbox-cards-list"
                  : "d-none"
                  // : "d-block bg-G-cancMe"
              }`}
            />



            <div id={modalOpened ? 'blueprint_image_variant_' + blueprintImage.print_sheet_code :"blueprint_image_" + blueprintImage.id}
                 className={`${blueprintImage.encasing_id && 'cursor-pointer'}`}>
             {/* All'utente devo comunicare se un prodotto è nella sua wishlist oppure no, ovvio solo nel caso in cui sia loggato.
                   Qui non inserisco il controllo sul login in quanto già blueprintImage.already_in_wishlist mi indica se l'utente è loggato o meno:
                   infatti se l'utente non è loggato non ho neppure il riferimento (id) alla wishlist, e la conseguenza di ciò è che blueprintImage.already_in_wishlist
                   abbia valore 0 che è quello di default.*/}
              {blueprintImage.already_in_wishlist > 0 && (
                <div id={'in_wishlist_'+ blueprintImage.id} className="position-absolute wishlist-icon-position-bpi"
                     onClick={(e) => handleNavigation(e, null, `/wishlists/${blueprintImage.already_in_wishlist}/edit`)}>
                  <IconTooltip
                    tooltipPosition={'top'}
                    tooltipIcon={'fas fa-heart'}
                    tooltipTitle={I18n.t('js.indexSealedPage.productInwishlistTitle')}
                    tooltipContent={I18n.t('js.indexSealedPage.productInwishlistContent')}
                    iconColor={'#00a2dd'}
                  />
                </div>
              )}
              {
                medium_image_url ?
                  <div className="d-flex justify-content-center position-relative text-center">
                    <img
                      className={
                        !blueprintImage.variants ||
                        blueprintImage.variants.length === 0 ||
                        modalOpened
                          ? 'image-card m-auto'
                          : 'image-card m-auto deck-shadow position-relative'
                      }
                      src={medium_image_url}
                      alt=""
                      onClick={(e) => displayVariantsHandler(e, i)}
                    />

                    {
                      !blueprintImage.encasing_id &&
                        <TextOverlayOnImage
                          textOverlay={I18n.t('js.common.notGradableProduct')}
                          size={'medium'}
                          type={'red-overlay'}
                          showNotGradableProductOverlay={!blueprintImage.encasing_id}
                        />
                    }
                  </div>
                :
                  <PlaceholderImage
                    size={'medium'}
                    additionalClasses={
                      !blueprintImage.variants ||
                      blueprintImage.variants.length === 0 ||
                      modalOpened
                        ? "image-card m-auto"
                        : "image-card m-auto deck-shadow position-relative"
                    }
                    showNotGradableProductOverlay={!blueprintImage.encasing_id}
                  />
              }
            </div>

            {(!blueprintImage.variants ||
              blueprintImage.variants.length === 0 ||
              modalOpened) ? (
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12 max-w-200px">
                    <button
                      id={modalOpened ? 'info_variant_' + blueprintImage.print_sheet_code : 'info_card_' + blueprintImage.id}
                      className="button -regular noselect col-12 mt-1 bg-dark rounded text-space text-light-gray"
                      style={{fontSize: "0.9rem"}}
                      onClick={(e) => handleNavigation(e, blueprintImage, `/blueprint_images/${blueprintImage.id}`)}
                    >
                      {I18n.t('js.indexCardPage.cardInfo')}
                    </button>
                  </div>

                    <div
                      className="col-12 d-flex card-number noselect mt-2 max-w-200px align-items-center justify-content-between">
                      <div className="col-4 text-right ml-2 mt-2 noselect p-0">
                        <p className="text-space text-dark-gray" style={{fontSize: "0.8rem", fontWeight: "500"}}>
                          {I18n.t('js.common.quantity')}:
                        </p>
                      </div>
                      <div className="col-6 text-left p-0">
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                            </Tooltip>
                          }
                        >
                          <div>
                        <input
                          className="form-control"
                          value={blueprintImage.quantity ? blueprintImage.quantity : ''}
                          name="bluprint_image_quantity"
                          id={"blueprint_image_quantity_" + blueprintImage.id}
                          type="number"
                          disabled={!blueprintImage.checked === true}
                          style={{width: "70px"}}
                          onKeyDown={(e) => onKeyDownQuantity(e)}
                          onChange={(e) => onChangeQuantity(e, i)}
                          data-id={blueprintImage.id}
                        />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>
                </div>
              </div>
            ) : (
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12 max-w-200px">
                    <a
                      id={`open_modal_variants_${blueprintImage.id}`}
                      className="button -regular noselect col-12 mt-1 bg-dark rounded text-space text-light-gray"
                      style={{fontSize: "0.9rem"}}
                      onClick={(e)=>displayVariantsHandler(e,i)}
                    >
                      {I18n.t('js.indexCardPage.btnOpenVariantsShow')}&nbsp;{blueprintImage.variants.length + 1}&nbsp;{I18n.t('js.indexCardPage.btnOpenVariantsCard')}
                    </a>
                  </div>
              </div>
              </div>
            )}
          </label>
        </div>
      </div>
    )
    : (
      <div key={blueprintImage.id}/>
    )

};

export default BlueprintImageItem;
